import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { ArrowSmallRight, VyIcon } from '@vy/ui-design-system';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { isEmptyArray } from '@vy/utils';
import React from 'react';
import { useActivatedIntegration } from '../../../../hooks/use-activated-integration';
import { useMenu } from '../../../../hooks/use-menu';
import { ShareCreditNoteEmailDialog } from './ShareCreditNoteEmailDialog';

type ShareCreditNoteMenuProps = {
  creditLedgerEntryId: string;
  customerName: string;
  contactEmails: string[];
  handleParentMenuClose: () => void;
  onSlackClick: () => void;
};

export const ShareCreditNoteMenu: React.FC<ShareCreditNoteMenuProps> = ({
  creditLedgerEntryId,
  customerName,
  contactEmails,
  handleParentMenuClose,
  onSlackClick,
}) => {
  const {
    isOpen: isShareMenuOpen,
    handleMenuOpen: handleShareMenuOpen,
    handleMenuClose: handleShareMenuClose,
    anchorElement: shareMenuAnchorElement,
  } = useMenu();

  const isSlackActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.slack, { suspense: false });
  const isEmailDisabled = isEmptyArray(contactEmails);
  const isSlackDisabled = !isSlackActivated;

  const handleSlackMenuItemClick = () => {
    handleShareMenuClose();
    handleParentMenuClose();
    onSlackClick();
  };

  return (
    <>
      <MenuItem onClick={handleShareMenuOpen} data-vy="credit-note-dot-menu-share">
        <ListItemIcon>
          <VyIcon
            icon="Share"
            color="black"
            style={{ transform: 'scale(0.7)' }}
          />
        </ListItemIcon>
        <ListItemText>Share via</ListItemText>
        <ArrowSmallRight />
      </MenuItem>

      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        open={isShareMenuOpen}
        anchorEl={shareMenuAnchorElement}
        onClose={handleShareMenuClose}
      >
        <ShareCreditNoteEmailDialog
          creditLedgerEntryId={creditLedgerEntryId}
          customerName={customerName}
          contactEmails={contactEmails}
        >
          <MenuItem
            disabled={isEmailDisabled}
            data-vy="credit-note-share-via-email"
          >
            <ListItemText>Email</ListItemText>
          </MenuItem>
        </ShareCreditNoteEmailDialog>

        <MenuItem
          onClick={handleSlackMenuItemClick}
          disabled={isSlackDisabled}
          data-vy="credit-note-share-via-slack"
        >
          <ListItemText>Slack</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
